var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"services-display"},_vm._l((_vm.$route.name=='home' ? 3 : 5),function(i){return _c('service',{key:i,attrs:{"service":_vm.services[i-1]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }